import _ from 'lodash';
import api from '@/api';
import { message } from 'antd';
import { saveAs } from 'file-saver';
import { actions as snActions } from './WorkOrderMultiSerialNumber/WorkOrderSerialNumber.redux';

const initialState = {
	selectedWODocNum: null,
	selectedWODocEntry: null,
	loggedEmpId: null,
	newWorkOrderDueDate: null,
	
	workOrderHeader: {},
	
	loadingWorkOrder: false,
	headerLoading: false,
	snSummaryLoading: false,
	componentsLoading: false,
	stagesLoading: false,
	stagesStatusSyncing: false,

	savingChanges: false,
	savingComponents: false,
	addingComponents: false,
	newComponentsSaved: false,
	includeClosed: false,
	
	newComponents: [],
	componentPage: 0,
	componentLimit: 10,
	componentList: [],
	componentPageSize: 10,
	componentListRowCount: 0,
	componentSearchString: '',
	
	stagePage: 0,
	stageLimit: 10,
	stagesListRowCount: 0,
	stageSearchString: '',
	stagesList: [],
	rowChangesList: [],
	stageListLoading: false,

	workOrderList: [],
	employeeList: [],
	teamsList: [],
	itemsList: [],
	snSummaryList: [],

	submitLastSNToComplete: false,

};


export const types = {
    SET_STATE: 'WORKORDERDETAILS/SET_STATE',
	UPDATE_STAGING_REQUEST: 'WORKORDERDETAILS/UPDATE_STAGING_REQUEST',
	ADD_LIST_ROW: 'WORKORDERDETAILS/ADD_LIST_ROW',
	REMOVE_LIST_ROW: 'WORKORDERDETAILS/REMOVE_LIST_ROW',
	UPDATE_COMPONENT_ROW: 'WORKORDERDETAILS/UPDATE_COMPONENT_ROW',
};


export const reducers = (state = initialState, action) => {

	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };


		case types.ADD_LIST_ROW:
			return {
				...state,
				newComponents: [
					...state.newComponents.slice(0),
					{
						...action.data,
					}
				]
			};


		case types.REMOVE_LIST_ROW:
			return {
				...state,
				newComponents: [
					...state.newComponents.slice(0, action.index),
					...state.newComponents.slice(action.index + 1),
				]
			}


		case types.UPDATE_COMPONENT_ROW:
			return {
				...state,
				componentList: [
					...state.componentList.slice(0, action.rowId),
					{
						...state.componentList[action.rowId],
						...action.row,

					},
					...state.componentList.slice(action.rowId + 1)
				]
			}


		case types.UPDATE_STAGING_REQUEST:
			return {
				...state, 
				rowChangesList: [
					...state.rowChangesList.slice(0, action.index),
					{
						...state.rowChangesList[action.index],
						...action.data,
					},
					...state.rowChangesList.slice(action.index + 1)
				],
			};


		default:
			return state;
	}

};

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	resetState: () => ({ type: types.SET_STATE, data: { ...initialState }}),

	updateStagingRequest: (index, data) => ({ type: types.UPDATE_STAGING_REQUEST, data, index }),

	addNewComponentRow: (newRow) => ({ type: types.ADD_LIST_ROW, data: newRow }),

	removeComponentRow: (index) => ({ type: types.REMOVE_LIST_ROW, index }),

	updateComponentRow: (rowId, row) => ({type: types.UPDATE_COMPONENT_ROW, rowId, row }),

	submitStageChange: () => async (dispatch, getState) => {
		const state               = getState(),
			  stageChanges        = state.workOrderReference.rowChangesList,
			  selectedWODocNum    = state.workOrderReference.selectedWODocNum,
			  newWorkOrderDueDate = state.workOrderReference.newWorkOrderDueDate,
			  submitLastSNToComplete = state.workOrderReference.submitLastSNToComplete,
			  docEntry               = stageChanges[0].DocEntry,
			  loggedEmpId            = state.workOrderReference.loggedEmpId,
			  employeeList           = state.workOrderReference.employeeList;

		// set loading flag so the user can't make any more changes while the page is saving
		dispatch(actions.setState({ savingChanges: true }));
		// Update TS_WO_ROUTE_SN_LIST table 
		if (submitLastSNToComplete) {
			try{
					let stageSNDataList = [];
					const employeeName  = employeeList.find(employee => employee.empID === loggedEmpId).Name || '';

					//Get Route SN data from stages that was updated by user
					for (const obj of stageChanges) { 
						let stageSNData = await api.get(`/workorders/workorder/${selectedWODocNum}/${obj.StageID}/serial_number_by_status`); 
						stageSNData.routeStageSerialNums.completedRev = obj.Revision ? obj.Revision : '';
						stageSNData.routeStageSerialNums.newStatus = obj.Status;
						stageSNDataList.push(stageSNData.routeStageSerialNums);

						//console.log('Processed SNs:', stageSNData.routeStageSerialNums);
						
					}
					// console.log('SN updating directly from table:', stageSNDataList); // DEBUG
					// now that we have our Code needed to update, process each SN in stageSNDataList to completed status
						await api.put(`/workorders/workorder/${selectedWODocNum}/serial_numbers/update`, {
							employeeName,
							serialNumbers: stageSNDataList,
						});

						dispatch(actions.setState({ submitLastSNToComplete: false }));
					
				} catch (e) {
					console.log(e);
					message.error(`Error updating Stages: ${e.errors}`);
				}
			}
		try{
			await api.put(`/workorders/workorder/${docEntry}/update`, {
					'ProductionOrdersStages': stageChanges,
					'workOrderDueDate': newWorkOrderDueDate
			});
			 // Refreshes SN summary data to output correct SN calculation
			await dispatch(snActions.loadWorkOrderSNSummary(selectedWODocNum));
			dispatch(actions.setState({ rowChangesList: [] }));
			dispatch(actions.setState({ newWorkOrderDueDate: null }));
			dispatch(actions.loadWorkOrderStages(selectedWODocNum));
			dispatch(actions.loadWorkOrderHeader(selectedWODocNum));
		} catch (e) {
			console.log(e);
			message.error(`Error updating Stages: ${e.errors}`);
		}
		dispatch(actions.setState({ savingChanges: false }));
	},

	submitNewComponents: () => async (dispatch, getState) => {
		const state        	= getState(),
			  docNum        = state.workOrderReference.selectedWODocNum,
			  componentList = state.workOrderReference.componentList,
			  newComponents = state.workOrderReference.newComponents,
			  docEntry      = componentList[0].DocEntry;

		dispatch(actions.setState({ savingComponents: true }));

		try {
			const results = await api.post(`/workorders/workorder/${docEntry}/components/add`, {
				newComponents
			});

			if (results.successful) {
				dispatch(actions.loadWorkOrderComponents(docNum));
				dispatch(actions.setState({ newComponentsSaved: true }));
				dispatch(actions.setState({ addingComponents: false }));
				dispatch(actions.setState({ newComponents: [] }));
			}


		} catch(e) {
			console.log(e);
		}

		dispatch(actions.setState({ savingComponents: false }));
	},

	loadWorkOrderHeader: (docNum) => async (dispatch) => {
		dispatch(actions.setState({ headerLoading: true }));

		try {
			const results = await api.get(`/workorders/workorder/${docNum}/header`);
							
			dispatch(actions.setState({ workOrderHeader: { ...results.header }}));
		} catch (e) {
			console.log(e);
		}

		dispatch(actions.setState({ headerLoading: false }));
	},

	loadWorkOrderComponents: (docNum) => async (dispatch, getState) => {
		const state          = getState(),
			  componentPage  = state.workOrderReference.componentPage,
			  componentLimit = state.workOrderReference.componentLimit;
		
		dispatch(actions.setState({ componentsLoading: true }));

		try {
			const results = await api.get(`/workorders/workorder/${docNum}/components`, {
				params: {
					componentPage,
					componentLimit,
				},
			});

			dispatch(actions.setState({ componentList: [ ...results.components.data ] }));
			dispatch(actions.setState({ componentListRowCount: results.components.rowCount }));

		} catch (e) {
			console.log(e);
		}

		dispatch(actions.setState({ componentsLoading: false }));
	},

	loadWorkOrderStages: (docNum) => async (dispatch, getState) => {
		const state          = getState(),
			  stagePage      = state.workOrderReference.stagePage,
			  stageLimit     = state.workOrderReference.stageLimit;
		let stagesWithStatusUpdates = []
		
		dispatch(actions.setState({ stagesLoading: true }));

		//run endpoint to check for inconsistencies with statuses
		try {
			const results = await api.get(`/workorders/workorder/${docNum}/stages/status_check`, {
				params: {
					docNum
				}
			});
			stagesWithStatusUpdates = results.stages.data;

		} catch (e) {
			console.log(`Error occurred checking stage statuses: ${e}`);
		}

		try {
			const results = await api.get(`/workorders/workorder/${docNum}/stages`, {
				params: {
					stagePage,
					stageLimit,
				},
			});

			let stageResults = results.stages.data;

			/* 
				If we have anything in stagesWithStatusUpdates that means there are inconsistencies with the stageResult's statuses, this will update any variances
				It is updating stagesWithStatusUpdates's statuses (current) to stageResults' status 
			*/
			if (stagesWithStatusUpdates.length) {
				dispatch(actions.setState({ stagesStatusSyncing: true }));
				let syncStages = [];

				stagesWithStatusUpdates.forEach(status => {
					const matchingStageResult = stageResults.find(result => result.StageID === status.U_TS_WO_RouteStage);
					if (matchingStageResult) {
						matchingStageResult.Status = status.RouteStatus; //update status to so we can write it
						syncStages.push(matchingStageResult);
					}
				});

				//sync SAP
				try {
					console.log('syncing stage statues....');
					let docEntry   = stageResults[0].DocEntry;
					
					await api.put(`/workorders/workorder/${docEntry}/update`, {
							'ProductionOrdersStages': syncStages,
							'workOrderDueDate': null,
							'syncStatus': true,
					});

				} catch (e) {
					console.log('There was an error syncing stages: ', e);
					message.error(`Error occurred syncing stage statuses to SAP: ${e}`);
				}

				//reload fresh stages
				try {
					const syncedResults = await api.get(`/workorders/workorder/${docNum}/stages`, {
						params: {
							stagePage,
							stageLimit,
						},
					});

					stageResults = syncedResults.stages.data;
					console.log('stageResults', stageResults)
				} catch (e) {
					console.log('There was an error getting synced stages: ', e);
					message.error(`Error occurred loading stages for: ${docNum}: ${e}`);
				}
			}

			dispatch(actions.setState({ stagesList: [ ...stageResults ] }));
			dispatch(actions.setState({ stagesListRowCount: results.stages.rowCount }));

		} catch (e) {
			console.log('There is an error getting stages for this work order. ', e);
			message.error(`Error occurred loading stages for: ${docNum}: ${e}`);
			
		}

		dispatch(actions.setState({ stagesStatusSyncing: false }));
		dispatch(actions.setState({ stagesLoading: false }));
	},

	loadEmployeeList: () => async (dispatch) => {

		try {
			const empResults  = await api.get('/employees'),
			      teamResults = await api.get('/employees/teams');

			dispatch(actions.setState({ employeeList: empResults.employees }));
			dispatch(actions.setState({ teamsList: teamResults.teams }));
		} catch (e) {
			console.log(e);
		}
	},

	loadUserInfo: () => async (dispatch) => {
		try {
			const results = await api.get('/employees/employee_id');

			dispatch(actions.setState({ loggedEmpId: results.empId }));
		} catch (e) {
			console.log(e);
		}
	},

	loadItemList: () => async (dispatch) => {
		try {
			const results = await api.get('/items');

			dispatch(actions.setState({ itemsList: results.items }));
		} catch (e) {
			console.log(e);
		}
	},

	loadWODocNumList: () => async (dispatch, getState) => {
		const state         = getState(),
			  includeClosed = state.workOrderReference.includeClosed;

		dispatch(actions.setState({ headerLoading: true }));
		try {
			const results = await api.get('/workorders/all/doc_nums', {
				params: {
					includeClosed
				}
			});

			dispatch(actions.setState({ workOrderList: results.work_orders }));
		} catch (e) {
			console.log(e);
		}

		
		dispatch(actions.setState({ headerLoading: false }));
	},

	getSNPedigreeFile: (docNum) => async (dispatch, getState) => {
		try {
			dispatch(actions.setState({stageListLoading: true}));
			const response = await api.get(`/workorders/workorder/stage_sn_pedigree/${docNum}/`, { responseType: 'text' });
			console.log('API Response:', response);


				const csvData = response.csvData;
				console.log('SNPedigree Route Stages', csvData);
	
				const makeCSVfile = (csv) => {
					try {
						//let dateParts = dayjs().local().format('DDMMYYYYHHMISS') + '.csv';
						//let saveName = 'SN_Pedigree_' + dateParts;
						let blob = new Blob([csv], { type: 'text/csv' });
						saveAs(blob);
					} catch (err) {
						console.error('Error occurred when attempting to create CSV file.', err);
					}
				};

				makeCSVfile(csvData);

		} catch (err) {
			console.log('Failed to create csv file.', err);
		}
		dispatch(actions.setState({stageListLoading: false}));
	},
};
